import {ThunkAction, ThunkDispatch} from "redux-thunk";
import {State} from "../reducers";
import {AnyAction} from "redux";

export interface RecaptchaWindow extends Window {
  grecaptcha: ReCaptchaV2.ReCaptcha;
}

export interface CustomDispatchProps {
  dispatch: GenericThunkDispatch;
}

export interface Dictionary<T> {
  [key: string]: T;
}

export enum ProductCardType {
  EPUB,
  Import
}

export enum ProductCardButtonAction {
  Edit,
  Delete,
  Duplicate
}

export type GenericThunkDispatch = ThunkDispatch<State, void, AnyAction>;

export type GenericThunkGetState = () => State;

export type GenericThunkAction<R> = ThunkAction<R, State, void, AnyAction>;

export type ArgumentAction = (...args: any[]) => AnyAction;

export enum LogLevel {
  Info,
  Warning,
  Error
}

export enum AjaxProgress {
  InProgress,
  Finished
}

/**
 * Options for any HTTP request in Redux passed to a "BEGIN" action
 */
export interface RequestOptions {
  hideLoader: boolean;
}

export interface ProjectConfigType {
  allowPdfImport: boolean;
  allowXmlZipImport: boolean;
}
